import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'do_workers_understand_information_included_within_their_written'

export const dataPointDefinition = {
  retracedId: 'do_workers_understand_information_included_within_their_written',
  name: 'Do workers understand the information included within their written terms and conditions documents?',
  description:
    'The intent of this question is to understand if workers actually understand the provisions or "information" that is included within their written terms and conditions documents. ',
  meta: {
    slcpMeta: {
      key: 'ep-3--6',
      number: 'RH-EMP-15',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ep-3--6', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26960,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
